import type { ArgoCDApplicationSourceResource } from "./argoCDApplicationSourceResource";
export interface ArgoCDApplicationResource {
    Id: string;
    Name: string;
    Annotations: Partial<Record<ArgoCDApplicationAnnotation, string>>;
    Sources: ArgoCDApplicationSourceResource[];
    ArgoCDGatewayId: string;
}
export type ArgoCDApplicationAnnotation = (typeof ArgoCDAnnotationKeys)[keyof typeof ArgoCDAnnotationKeys];
export const ArgoCDAnnotationKeys = {
    Project: "argo.octopus.com/project",
    Tenant: "argo.octopus.com/tenant",
    Environment: "argo.octopus.com/environment",
    DefaultImageRegistry: "argo.octopus.com/image-update-default-registry",
    HelmImageReplacePathPrefix: "argo.octopus.com/image-replace-path",
} as const;
